










































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AddKnowledge from "./addKnowledge.vue";
import {
  QueryPatientEduModel,
  SaveEducationModel
} from "@/api/pdOutPatient/pdEducation/pdPatientEdu";
import fileShow from "../pdKnowledge/fileShow.vue";
import eduPreview from "../pdKnowledge/pdPreviousEducationPlay.vue";
@Component({ components: { AddKnowledge,fileShow,eduPreview } })
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  @Prop({ type: String, default: {} }) title: string;
  loading = false;
  form: any = {};
  knowledgeList: any[] = [];
  showKnowledge = false;
  showPreview: boolean = false;
  previewData: any = {};
  knowledgeId = "";
  columns = [
    {
      title: "材料名称",
      key: "knowledgeName",
      minWidth: 300
    },
    {
      title: "操作",
      minWidth: 170,
      render: (h: any, p: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small"
              },
              style: {
                marginRight: "10px"
              },
              on: {
                click: () => {
                  this.deleteKnowledge(p.row);
                }
              }
            },
            "删除"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "10px"
              },
              on: {
          click: () => {
                this.preview(p.row);
                },
              },
            },
            "预览"
          ),
        ]);
      }
    }
  ];
  async created() {
    this.form = Object.assign({}, this.data);
    if (this.form && this.form.detail) {
      this.knowledgeList = this.form.detail;
    }
  }
  rules = {};
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    let data = {
      modelName: this.form.modelName,
      modelNote: this.form.modelNote,
      saveType: this.form.saveType,
      id: this.form.id,
      detail: this.knowledgeList
    };
    await SaveEducationModel(data);
    this.$emit("input", false);
    this.$emit("on-success");
  }
  deleteKnowledge(item: any) {
    this.knowledgeList = this.knowledgeList.filter((x: any) => {
      return x.knowledgeId != item.knowledgeId;
    });
  }
    viewData:any={};
    viewShow=false;
  preview(row: any) {
        this.viewData=row;
        this.viewShow = true;
    }
  addKnowledge() {
    this.knowledgeId = "";
    if (this.knowledgeList) {
      this.knowledgeList.forEach(x => {
        this.knowledgeId += x.knowledgeId.toString() + ";";
      });
      this.knowledgeId = this.knowledgeId.substring(
        0,
        this.knowledgeId.length - 1
      );
    }
    this.showKnowledge = true;
  }
  setKnowledge(item: any) {
      console.log(item);
    item.data.forEach(x => {
      this.knowledgeList.push({knowledgeId:x.id,knowledgeName:x.name});
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdEducationModel/addOrEditEduModel.vue